"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PENDO_API_KEY = void 0;
exports.PENDO_API_KEY = '11227d4b-0f21-4d16-48d8-79043bbb1dbf';
